/**
 * @desc pms-根据供应商编号查询供应商sku报价
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.RpcSupplierQuotationBySupplierIdNameList, options?: any) {
  return updateResponse(
    http(URL + `/getSupplierQuotationBySupplierIdNameList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
